import { LocalizationTexts, TranslationOptions } from './types';

export enum OptimusTextKey {
    Back = 'Back',
    Cancel = 'Cancel',
    CharactersLeft = 'CharactersLeft',
    ChartEmptyDefaultMessage = 'ChartEmptyDefaultMessage',
    ChartErrorDefaultMessage = 'ChartErrorDefaultMessage',
    ChooseFile = 'ChooseFile',
    Clear = 'Clear',
    ClearSelection = 'ClearSelection',
    ClearTheSignature = 'ClearTheSignature',
    ClickToClose = 'ClickToClose',
    Close = 'Close',
    CloseBanner = 'CloseBanner',
    CloseDialog = 'CloseDialog',
    CollapseAccordion = 'CollapseAccordion',
    Custom = 'Custom',
    DeselectAll = 'DeselectAll',
    Decrement = 'Decrement',
    ExpandAccordion = 'ExpandAccordion',
    Format = 'Format',
    Increment = 'Increment',
    Information = 'Information',
    DialogedDatePickerCancel = 'DialogedDatePickerCancel',
    DropzoneFileLimitOverReachedError = 'DropzoneFileLimitOverReachedError',
    DropzoneFileLimitReached = 'DropzoneFileLimitReached',
    Error = 'Error',
    Help = 'Help',
    HideColumn = 'HideColumn',
    ItemsSelected = 'ItemsSelected',
    ItemsSelectedOutOfTotal = 'ItemsSelectedOutOfTotal',
    LastMonth = 'LastMonth',
    LastQuarter = 'LastQuarter',
    LastWeek = 'LastWeek',
    LastYear = 'LastYear',
    Loading = 'Loading',
    MewsLogo = 'MewsLogo',
    NextMonth = 'NextMonth',
    NextQuarter = 'NextQuarter',
    NextWeek = 'NextWeek',
    NextYear = 'NextYear',
    NoItems = 'NoItems',
    NoResultsForSearch = 'NoResultsForSearch',
    NotSelected = 'NotSelected',
    Of = 'Of',
    Ok = 'Ok',
    Optional = 'Optional',
    Or = 'Or',
    PauseVideo = 'PauseVideo',
    PlayVideo = 'PlayVideo',
    PreviousMonth = 'PreviousMonth',
    Remove = 'Remove',
    ResetToDefault = 'ResetToDefault',
    Search = 'Search',
    SelectAll = 'SelectAll',
    SelectDate = 'SelectDate',
    SelectMonth = 'SelectMonth',
    SignatureInput = 'Input your signature',
    Selected = 'Selected',
    SelectedAsStartDate = 'SelectedAsStartDate',
    SelectedAsEndDate = 'SelectedAsEndDate',
    SelectEmptyMessage = 'SelectEmptyMessage',
    ShowAll = 'ShowAll',
    Success = 'Success',
    TableClearFilters = 'TableClearFilters',
    TableCollapseAllGroups = 'TableCollapseAllGroups',
    TableColumnSettings = 'TableColumnSettings',
    TableDragToReorder = 'TableDragToReorder',
    TableEmptyStatePrimary = 'TableEmptyStatePrimary',
    TableExpandAllGroups = 'TableExpandAllGroups',
    TableFilterAfter = 'TableFilterAfter',
    TableFilterBefore = 'TableFilterBefore',
    TableFilterBetween = 'TableFilterBetween',
    TableFilterBySearch = 'TableFilterBySearch',
    TableFilterContains = 'TableFilterContains',
    TableFilterEndsWith = 'TableFilterEndsWith',
    TableFilterEquals = 'TableFilterEquals',
    TableFilterGreaterThan = 'TableFilterGreaterThan',
    TableFilterGreaterThanOrEqual = 'TableFilterGreaterThanOrEqual',
    TableFilterIn = 'TableFilterIn',
    TableFilterLessThan = 'TableFilterLessThan',
    TableFilterLessThanOrEqual = 'TableFilterLessThanOrEqual',
    TableFilterNotIn = 'TableFilterNotIn',
    TableFilterStartsWith = 'TableFilterStartsWith',
    TableFilterFrom = 'TableFilterFrom',
    TableFilterTo = 'TableFilterTo',
    TableGroupBy = 'TableGroupBy',
    TableGroupByLabel = 'TableGroupByLabel',
    TableGroupByNone = 'TableGroupByNone',
    TableGroupByThisColumn = 'TableGroupByThisColumn',
    TableGroupColumnHeader = 'TableGroupColumnHeader',
    TableHeaderSearch = 'TableHeaderSearch',
    TablePaginationItemsCount = 'TablePaginationItemsCount',
    TablePaginationShow = 'TablePaginationInfoShow',
    TablePaginationSizeItemsCount = 'TablePaginationSizeItemsCount',
    TablePinLeft = 'TablePinLeft',
    TablePinRight = 'TablePinRight',
    TableSortAscending = 'TableSortAscending',
    TableSortClear = 'TableSortClear',
    TableSortDescending = 'TableSortDescending',
    TableUngroupAll = 'TableUngroupAll',
    TableUnpin = 'TableUnpin',
    ThisMonth = 'ThisMonth',
    ThisQuarter = 'ThisQuarter',
    ThisWeek = 'ThisWeek',
    ThisYear = 'ThisYear',
    Today = 'Today',
    Tomorrow = 'Tomorrow',
    Warning = 'Warning',
    Yesterday = 'Yesterday',
}

export const defaultTranslations: LocalizationTexts = {
    [OptimusTextKey.Back]: 'Back',
    [OptimusTextKey.Cancel]: 'Cancel',
    [OptimusTextKey.CharactersLeft]: ({ count }: TranslationOptions = {}) => `${count} characters left`,
    [OptimusTextKey.ChartEmptyDefaultMessage]:
        'There are no data for current filter, try to adjust the filter to see results.',
    [OptimusTextKey.ChartErrorDefaultMessage]: 'There was a problem loading the data, try refreshing this page.',
    [OptimusTextKey.ChooseFile]: 'Choose file',
    [OptimusTextKey.Clear]: 'Clear',
    [OptimusTextKey.ClearSelection]: 'Clear selection',
    [OptimusTextKey.ClearTheSignature]: 'Clear the signature',
    [OptimusTextKey.ClickToClose]: 'Click to close',
    [OptimusTextKey.Close]: 'Close',
    [OptimusTextKey.CloseBanner]: 'Close banner',
    [OptimusTextKey.CloseDialog]: 'Close dialog',
    [OptimusTextKey.CollapseAccordion]: 'Collapse accordion item',
    [OptimusTextKey.Custom]: 'Custom',
    [OptimusTextKey.Decrement]: 'Decrement',
    [OptimusTextKey.Error]: 'Error',
    [OptimusTextKey.ExpandAccordion]: 'Expand accordion item',
    [OptimusTextKey.Format]: 'Format',
    [OptimusTextKey.Increment]: 'Increment',
    [OptimusTextKey.Information]: 'Information',
    [OptimusTextKey.DeselectAll]: 'Deselect all',
    [OptimusTextKey.DialogedDatePickerCancel]: 'Cancel',
    [OptimusTextKey.DropzoneFileLimitOverReachedError]: ({
        maxFilesLimit,
        filesOverLimitAmount,
    }: TranslationOptions = {}) => `You can upload max. ${maxFilesLimit} files. Please remove ${filesOverLimitAmount}.`,
    [OptimusTextKey.DropzoneFileLimitReached]: ({ maxFilesLimit }: TranslationOptions = {}) =>
        `You can upload max. ${maxFilesLimit} files.`,
    [OptimusTextKey.Help]: 'Help',
    [OptimusTextKey.HideColumn]: 'Hide column',
    [OptimusTextKey.ItemsSelected]: ({ count }: TranslationOptions = {}) => `${count} items selected`,
    [OptimusTextKey.ItemsSelectedOutOfTotal]: ({ count, total }: TranslationOptions = {}) =>
        `${count} out of ${total} selected`,
    [OptimusTextKey.LastMonth]: 'Last month',
    [OptimusTextKey.LastQuarter]: 'Last quarter',
    [OptimusTextKey.LastWeek]: 'Last week',
    [OptimusTextKey.LastYear]: 'Last year',
    [OptimusTextKey.Loading]: 'Loading',
    [OptimusTextKey.MewsLogo]: 'Mews logo',
    [OptimusTextKey.NextMonth]: 'Next month',
    [OptimusTextKey.NextQuarter]: 'Next quarter',
    [OptimusTextKey.NextWeek]: 'Next week',
    [OptimusTextKey.NextYear]: 'Next year',
    [OptimusTextKey.NoItems]: 'No items',
    [OptimusTextKey.NoResultsForSearch]: 'No results found. Try another keyword',
    [OptimusTextKey.NotSelected]: 'Not selected',
    [OptimusTextKey.Of]: 'Of',
    [OptimusTextKey.Ok]: 'Ok',
    [OptimusTextKey.Optional]: 'Optional',
    [OptimusTextKey.Or]: 'or',
    [OptimusTextKey.PauseVideo]: 'Pause video',
    [OptimusTextKey.PlayVideo]: 'Play video',
    [OptimusTextKey.PreviousMonth]: 'Previous month',
    [OptimusTextKey.Remove]: 'Remove',
    [OptimusTextKey.ResetToDefault]: 'Reset to default',
    [OptimusTextKey.Search]: 'Search',
    [OptimusTextKey.SelectAll]: 'Select all',
    [OptimusTextKey.SelectDate]: 'Select date',
    [OptimusTextKey.SelectMonth]: 'Select month',
    [OptimusTextKey.SignatureInput]: 'Input your signature',
    [OptimusTextKey.SelectEmptyMessage]: 'No value',
    [OptimusTextKey.Selected]: 'Selected',
    [OptimusTextKey.SelectedAsStartDate]: 'Selected as start date',
    [OptimusTextKey.SelectedAsEndDate]: 'Selected as end date',
    [OptimusTextKey.ShowAll]: 'Show all',
    [OptimusTextKey.Success]: 'Success',
    [OptimusTextKey.TableClearFilters]: 'Clear filters',
    [OptimusTextKey.TableCollapseAllGroups]: 'Collapse all groups',
    [OptimusTextKey.TableColumnSettings]: 'Column settings',
    [OptimusTextKey.TableDragToReorder]: 'Drag to reorder',
    [OptimusTextKey.TableEmptyStatePrimary]: 'No data available',
    [OptimusTextKey.TableExpandAllGroups]: 'Expand all groups',
    [OptimusTextKey.TableFilterAfter]: 'After',
    [OptimusTextKey.TableFilterBefore]: 'Before',
    [OptimusTextKey.TableFilterBetween]: 'Between',
    [OptimusTextKey.TableFilterBySearch]: 'Filter by search',
    [OptimusTextKey.TableFilterContains]: 'Contains',
    [OptimusTextKey.TableFilterEndsWith]: 'Ends with',
    [OptimusTextKey.TableFilterEquals]: 'Equals',
    [OptimusTextKey.TableFilterGreaterThan]: 'Greater than',
    [OptimusTextKey.TableFilterGreaterThanOrEqual]: 'Greater than or equal',
    [OptimusTextKey.TableFilterIn]: 'Is in',
    [OptimusTextKey.TableFilterLessThan]: 'Less than',
    [OptimusTextKey.TableFilterLessThanOrEqual]: 'Less than or equal',
    [OptimusTextKey.TableFilterNotIn]: 'Is not in',
    [OptimusTextKey.TableFilterStartsWith]: 'Starts with',
    [OptimusTextKey.TableFilterFrom]: 'From',
    [OptimusTextKey.TableFilterTo]: 'To',
    [OptimusTextKey.TableGroupBy]: 'Group by',
    [OptimusTextKey.TableGroupByLabel]: ({ label }: TranslationOptions = {}) => `Group by: ${label}`,
    [OptimusTextKey.TableGroupByNone]: 'Group by: None',
    [OptimusTextKey.TableGroupByThisColumn]: 'Group by this column',
    [OptimusTextKey.TableGroupColumnHeader]: 'Group',
    [OptimusTextKey.TableHeaderSearch]: 'Search',
    [OptimusTextKey.TablePaginationItemsCount]: ({ items }: TranslationOptions = {}) =>
        `${items} ${items !== 1 ? 'items' : 'item'}`,
    [OptimusTextKey.TablePaginationShow]: 'Show',
    [OptimusTextKey.TablePaginationSizeItemsCount]: ({ items }: TranslationOptions = {}) => `of ${items} items`,
    [OptimusTextKey.TablePinLeft]: 'Pin left',
    [OptimusTextKey.TablePinRight]: 'Pin right',
    [OptimusTextKey.TableSortAscending]: 'Sort ascending',
    [OptimusTextKey.TableSortClear]: 'Clear sorting',
    [OptimusTextKey.TableSortDescending]: 'Sort descending',
    [OptimusTextKey.TableUngroupAll]: 'Ungroup all',
    [OptimusTextKey.TableUnpin]: 'Unpin',
    [OptimusTextKey.ThisMonth]: 'This month',
    [OptimusTextKey.ThisQuarter]: 'This quarter',
    [OptimusTextKey.ThisWeek]: 'This week',
    [OptimusTextKey.ThisYear]: 'This year',
    [OptimusTextKey.Today]: 'Today',
    [OptimusTextKey.Tomorrow]: 'Tomorrow',
    [OptimusTextKey.Warning]: 'Warning',
    [OptimusTextKey.Yesterday]: 'Yesterday',
};
